import React from "react"
import StatusBadge from "./StatusBadge"
import { TransferApplication } from "../types"
import dayjs from "dayjs"
import { useDownloadTransferCsv } from "../hooks/useDownloadTransferCsv"

interface TransferApplicationItemHeaderProps {
  application: TransferApplication
}

const TransferApplicationItemHeader: React.FC<TransferApplicationItemHeaderProps> = ({
  application,
}) => {
  const { downloadTransferCsv } = useDownloadTransferCsv()

  const handleCsvDownload = async () => {
    await downloadTransferCsv(application.id)
  }

  const formatAmount = (amount: number): string => {
    return amount.toLocaleString() + "円"
  }

  const sumOfadvancedRemittanceAmount = application.payments.reduce(
    (acc, payment) => acc + payment.advancedRemittanceAmount,
    0
  )

  return (
    <div className="flex items-center justify-between gap-20 py-4">
      <div className="flex items-center gap-5">
        <StatusBadge status={application.status} />

        <div className="flex flex-col gap-2">
          <div className="text-lg text-black">
            <span className="font-normal">ID</span>
          </div>
          <div className="text-lg font-normal text-black">{application.id}</div>
        </div>

        <div className="flex flex-col gap-2">
          <div className="text-lg text-black">
            <span className="font-normal">発行日時</span>
          </div>
          <div className="text-lg font-normal text-black">
            {dayjs(application.createdAt).format("YYYY/MM/DD HH:mm:ss")}
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <div className="text-lg text-black">
            <span className="font-normal">金額</span>
          </div>
          <div className="text-lg font-normal text-black">
            {formatAmount(sumOfadvancedRemittanceAmount)}
          </div>
        </div>

        <div className="flex flex-col gap-2">
          <div className="text-lg text-black">
            <span className="font-normal">発行者</span>
          </div>
          <div className="text-lg font-normal text-black">{application.email}</div>
        </div>
      </div>

      <button
        onClick={handleCsvDownload}
        className="border border-solid border-medium-gray bg-white px-3 py-4 text-lg text-black hover:bg-gray-50 rounded-md"
      >
        csvをダウンロード
      </button>
    </div>
  )
}

export default TransferApplicationItemHeader
